/* eslint-disable @typescript-eslint/naming-convention */
import type { CTA } from '@ps/web-martech-cms-types';
import { RawButton } from '@ps/web-shared-components';
import type { ClassNameProp } from '@ps/web-shared-components';
import classNames from 'clsx';
import { omit, pick } from 'lodash';
import type { ButtonHTMLAttributes } from 'react';
import React from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';

import { select } from '@swf/core/store';
import { routeHandler } from '@swf/core/utils/c2l';

import useAuthenticatedContent from '../../hooks/useAuthenticatedContent';
import usePostDownloadNavigation from '../../hooks/usePostDownloadNavigation';

import styles from './CMSCTA.scss';

interface Props {
  space?: boolean;
  grow?: boolean;
}

const ButtonType = 'text';
const CTAProps = ['url', 'rel', 'title', 'target', 'track_id'];

const CMSCTA: React.FC<
  CTA & Partial<ClassNameProp> & ButtonHTMLAttributes<HTMLButtonElement> & Props
> = ({ space = true, grow = false, children, className, hard_refresh, logged_in_cta, ...rest }) => {
  const history = useHistory();
  const postDownloadNavigate = usePostDownloadNavigation();
  const localePrefix = useSelector(select.location.getLocaleURL);
  const { url, rel, title, target, track_id } = useAuthenticatedContent(
    pick(rest, CTAProps),
    logged_in_cta
  );

  const onClick = (e: React.MouseEvent) => {
    postDownloadNavigate(url);

    if (hard_refresh && url) {
      e.preventDefault();
      window.location.assign(`${localePrefix}${url}`);
    } else {
      routeHandler(url, history, e);
    }
  };

  return title ? (
    <div
      className={classNames(
        styles.container,
        space && styles.space,
        grow && styles.grow,
        className
      )}
    >
      <RawButton
        track
        href={url}
        trackText={track_id}
        variant={ButtonType}
        className={styles.cta}
        rel={url && rel ? rel : undefined}
        onClick={(e: React.MouseEvent) => onClick(e)}
        target={url ? target : undefined}
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        {...(omit(rest, CTAProps) as any)}
      >
        {title || children}
      </RawButton>
    </div>
  ) : null;
};

export default CMSCTA;
